<script lang="ts" setup>
const { t } = useI18n();

const { data: articles } = await useAsyncData('articles', () =>
  queryCollection('article')
    .select('path', 'image', 'shortTitle', 'description')
    .all(),
);
</script>

<template>
  <section class="w-full pt-header p-section">
    <Head>
      <Title>{{ t('meta.articles.title') }}</Title>
      <Meta name="description" :content="t('meta.articles.description')" />
      <Meta name="keywords" :content="t('meta.articles.keywords')" />

      <Meta property="og:title" :content="t('meta.articles.title')" />
      <Meta
        property="og:description"
        :content="t('meta.articles.description')"
      />
    </Head>

    <h1 class="block text-3xl md:text-5xl mb-8 text-center text-900 mt-8">
      {{ t('title') }}
    </h1>

    <div
      v-if="articles?.length"
      class="lg:container grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 px-4 pt-8 pb-12"
    >
      <NuxtLink
        v-for="article in articles"
        :key="article.path"
        :to="`/articles${article.path}`"
      >
        <Card
          class="h-full transition hover:shadow-5"
          :pt="{
            header: 'overflow-hidden rounded-inherit',
            body: '!p-5',
            content: 'leading-5',
          }"
        >
          <template #header>
            <div
              class="relative before:content-[''] before:absolute before:bottom-0 before:w-full before:h-full before:bg-gradient-to-b before:from-black/[.2] before:to-black/[.8]"
            >
              <NuxtImg
                :alt="article.image.alt"
                :src="article.image.src"
                format="webp"
                class="block object-cover w-full aspect-article"
              />
              <h2 class="absolute bottom-0 w-full m-0 p-5 text-xl sm:text-2xl">
                {{ article.shortTitle }}
              </h2>
            </div>
          </template>

          <template #content>
            {{ article.description }}
          </template>
        </Card>
      </NuxtLink>
    </div>
    <p
      v-else
      class="text-xl md:text-2xl lg:text-3xl text-800 text-center px-5 md:px-6 mt-8"
    >
      {{ t('empty') }}
    </p>
  </section>
</template>

<i18n src="~/locales/meta.yaml"></i18n>
<i18n>
en:
  title: Articles about sex
  empty: No articles found for your language

ru:
  title: Статьи о сексе
  empty: Для вашего языка не найдено ни одной статьи

de:
  title: Artikel über Sex
  empty: Für Ihre Sprache wurden keine Artikel gefunden

es:
  title: Artículos sobre sexo
  empty: No se encontraron artículos para su idioma.

fr:
  title: Articles sur le sexe
  empty: Aucun article trouvé pour votre langue
</i18n>
